import React, { useContext, useEffect } from 'react';
import styles from './passwordgen.module.css';
import { Trial } from '~/common/pages/Trial/Trial';
import { CONTENT_IDS, TRIAL_TYPES } from '~/common/consts';
import { TrialContentProvider } from '~/common/provider/TrialContentProvider';
import { TrialContentContext } from '~/common/context/ContentContext';
import { useAppStore } from '~/common/store/appStore';
import { useShallow } from 'zustand/react/shallow';
import { InfoBanner } from '~/common/components/InfoBanner';

const PasswordGenContent = () => {
  const data = useContext(TrialContentContext);
  const card1 = data?.card1;

  if (!data) {
    return (
      <div className={styles['modal-cols']}>
        <div className={styles['modal-col1']}>
          <div className={`${styles.contentLine} ${styles.contentLine28}`}></div>
          <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
          <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
          <Trial />
        </div>
        <div className={styles['modal-col2']}>
          <div className={`${styles.contentLine} ${styles.contentLineImage}`}></div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['modal-cols']}>
      <div className={styles['modal-col1']}>
        {data.successMessage && <InfoBanner text={data.successMessage} success />}
        {card1?.title && <h3>{card1.title}</h3>}
        {card1?.text && <p style={{ marginBottom: '20px' }}>{card1.text}</p>}
        <Trial />
      </div>
      <div className={styles['modal-col2']}>
        {card1?.image && <img src={card1.image} alt={card1.title} />}
      </div>
    </div>
  );
};

const PasswordGen = () => {
  const { setContentId, setTrialLength, setTrialType } = useAppStore(
    useShallow((state) => ({
      setContentId: state.setContentId,
      setTrialLength: state.setTrialLength,
      setTrialType: state.setTrialType,
    }))
  );
  useEffect(() => {
    setTrialType(TRIAL_TYPES.PREMIUM);
    setContentId(CONTENT_IDS.PREMIUM);
    setTrialLength(30);
  }, []);

  return (
    <TrialContentProvider>
      <PasswordGenContent />
    </TrialContentProvider>
  );
};

export default PasswordGen;
